<template>
  <div class="radio-input">
    <div class="radio-input__text">
      <slot></slot>
    </div>
    <div class="radio-input-radiobox">
      <checkbox-input :value="!value" @click.native="emitInput(false)">
        {{ $t('common.no') }}
      </checkbox-input>
      <checkbox-input :value="value" @click.native="emitInput(true)">
        {{ $t('common.yes') }}
      </checkbox-input>
    </div>
  </div>
</template>

<script>
import CheckboxInput from '@/components/inputs/CheckboxInput.vue'
export default {
  name: 'RadioInput',
  components: { CheckboxInput },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="scss">
.radio-input {
  &__text {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 16px;
  }

  &-radiobox {
    display: flex;
    align-items: center;
    column-gap: 32px;
  }
}
</style>
